import { cn } from "@/lib/utils";

interface FormCardProps {
  title?: string;
  subtitle?: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
  sticky?: boolean;
}

export default function FormCard({
  title,
  subtitle,
  description,
  children,
  className,
  sticky = false,
}: FormCardProps) {
  return (
    <div
      className={cn(
        "bg-white p-6 rounded-lg border border-border",
        sticky && "sticky top-24",
        className
      )}
    >
      {(title || subtitle || description) && (
        <div className="mb-6">
          {title && (
            <h3 className="font-heading text-xl uppercase text-navy mb-2">
              {title}
            </h3>
          )}
          {subtitle && (
            <p className="text-sm text-muted-foreground">{subtitle}</p>
          )}
          {description && (
            <p className="text-sm text-muted-foreground mt-1">{description}</p>
          )}
        </div>
      )}
      {children}
    </div>
  );
}
